import { api } from "api";
import { useQuery } from "@tanstack/react-query";
import type { RefundStatusRequest } from "api/requests";

/**
 * Client hook to query for refund status.
 * Works for Stripe only.
 * @returns React Query properties.
 */
export function useTransactionRefundStatus(request: RefundStatusRequest | null) {
    return useQuery({
        queryKey: ["transactionRefundStatus", request],
        queryFn: async (context) => await api.transaction.refundStatus(request!, context.signal),
        enabled: !!request,
        refetchInterval: 2000,
    });
}
